export default __webpack_public_path__ + "static/media/download-icon.07d215e6.svg";